import { FC, useState, useEffect } from 'react';
import { getBundleRequestSlots } from '@commerce-cart-webcomponents/sdk';
import { useSession } from '@nextgen-web-framework/all';
import { AddToListToggle } from '@commerce-cart-webcomponents/ui-composite';
import type { AddToWishlistContainerPropsTypes } from './types/propsTypes';

const AddToWishlistContainer: FC<AddToWishlistContainerPropsTypes> = ({
  className,
  productData,
  isPDP,
  isPLPCard,
  bundleState = [],
  isBundle,
  withText,
}): React.JSX.Element => {
  const { isAnonymous, session } = useSession();
  const bundleSlots = getBundleRequestSlots(bundleState);
  const [isAnonymousUser, setIsAnonymousUser] = useState(false);

  useEffect(() => {
    setIsAnonymousUser(isAnonymous());
  }, [session]);

  if (isAnonymousUser) {
    return <></>;
  }

  return (
    <AddToListToggle
      bundleSlots={bundleSlots}
      productData={{ ...productData }}
      className={className}
      isPDP={isPDP}
      isPLPCard={isPLPCard}
      disabled={false}
      isBundleProduct={isBundle}
      withText={withText}
      productDetailsPageURL={`/product/${productData?.productId}`}
    />
  );
};

export default AddToWishlistContainer;
export type { AddToWishlistContainerPropsTypes };
